import React from 'react';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer,
} from 'recharts';

const inr = (n) => `₹${Math.round(n).toLocaleString('en-IN')}`;

// data: [{ label, registrations, revenue }]
const TrendChart = ({ data = [], height = 260 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <ComposedChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -8 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
      <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#94a3b8' }} tickLine={false} axisLine={false} interval="preserveStartEnd" minTickGap={24} />
      <YAxis yAxisId="left" tick={{ fontSize: 11, fill: '#94a3b8' }} tickLine={false} axisLine={false} allowDecimals={false} />
      <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 11, fill: '#94a3b8' }} tickLine={false} axisLine={false} tickFormatter={(v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : v)} />
      <Tooltip formatter={(value, name) => (name === 'revenue' ? [inr(value), 'Revenue'] : [value, 'Registrations'])} />
      <Bar yAxisId="left" dataKey="registrations" fill="#c7d2fe" radius={[4, 4, 0, 0]} maxBarSize={28} />
      <Line yAxisId="right" dataKey="revenue" stroke="#6d28d9" strokeWidth={2.5} dot={false} />
    </ComposedChart>
  </ResponsiveContainer>
);

export default TrendChart;
